export const PLAYMATEZAPI = {
  login: "users/v3/userLogin",
  generateNewJwtToken: "/users/generateNewJwtToken",
  checkEmailOrPhoneNumberExistOrNot:
    "/users/v2/checkEmailOrPhoneNumberExistOrNot",
  sentOtp: "users/v2/sendVerificationCode",
  hideUserEmail: "users/v2/hideUserEmail",
  verifyOtp: "/users/v2/verifyOtp",
  registrationUser: "users/v5/userRegistration",
  resetPassword: "/users/v4/resetPassword",
  socialLogin: "/users/v4/socialLogin",
  changePassword: "/users/changePassword",
  updateProfile: "/users/v5/updateUserProfile",
  getConfig: "/users/getConfig",
  uploadProofImages: "users/v2/uploadReportEvidenceImages",
  userImageUpload: "users/v2/userImageUpload",
  deleteProfileImage: "users/v2/deleteImage",
  getNotificationList: "/player/v3/getAllNotificationsList",
  checkReferenceId: "/cards/checkReferenceId",
  joinRequestDetail: "/joinRequest/joinRequestDetail",
  gameOnCardDetail: "/cards/v2/cardDetail",
  countMyUnreadNotification: "/users/countMyUnreadNotification",
  readUnreadNotification: "/users/readUnreadNotification",
  deleteNotifications: "/dashboard/deleteMultipleNotifications",
  downloadBookingHistoryExcel:"/payment/v3/downloadSaleExcel",
  event: {
    addEvent: "/event/createEvent",
    updateEvent: "/event/updateEvent",
  },
  rating: {
    marketPlaceRating: "/ratingReview/v2/getAllProductRatingReviews ",
    venueRating: "/ratingReview/v2/userRatingReviewsList",
    addRatingReviews: "/ratingReview/v2/userAddRatingReviews ",
  },
  venueOperation: {
    venueAvailabilityDetails: "/venueBooking/getVenueAvailabilityDetails",
    updateVenueAvailability: "/venueBooking/v2/updateVenueAvailability",
    setVenueAvailability: "venueBooking/setVenueAvailability ",
    fetchSportListWithSelectedSport: "/users/fetchSportListWithSelectedSport",
    addUpdateArena: "/venueBooking/v3/selectSports",
    getBookingAvailiabilityList: "/venueBooking/v2/getSelectedSportsList",
    bookingAvailiabilityDetails: "/venueBooking/v2/selectedSportsDetail",
    listOfVenueSlots: "/venueBooking/v3/_getListOfVenueSlots",
    blockBookingSlots: "/venueBooking/V4/slotBookingFromVenueSide ", //change v2 to v3 by ishika
    unblockBookingSlots: "/venueBooking/v2/cancelSlot",
    venueBookedSlotListing: "/venueBooking/v3/venueBookedSlotListing", //change v2 to v3 by ishika
    deleteBooking: "/dashboard/deletes ",
    updateArena: "/venueBooking/v4/updateSelectedSports",
  },
  user: {
    getUserDetails: "/users/getUserProfile",
    getOtherUserProfileDetails: "/users/v2/getUserDetail", // get profile details of other users(players)
    deleteUserAccount: "/users/userDelete ",
    getAcceptConnectionList: "/player/getAcceptConnectionList",
    userReports: "users/v2/userReports",
    venueListBasedOnPrimarySport: "/venue/venueListBasedOnPrimarySport",
  },
  venue: {
    getVenueDetails: "/venue/v4/venueDetails",
    cancelSlots: "/venueBooking/venueCancelRefund",
    cancelOfflineBookedSlots: "/venueBooking/v4/cancelOfflineBookedSlots",
    rescheduleSlotByVenue: "/venueBooking/_venueReschedule",
    rescheduleOfflineBookedSlots:
      "/venueBooking/v4/rescheduleOfflineBookedSlots",
    collectPaymentOfflineBooking: "/venueBooking/v4/collectPaymentOfflineBooking",
    venueAddressSearch: "/venue/v2/venueAddressSearch",
    createGameOn: "/cards/v2/createGameOn",
    getAllPlayerList: "/player/v2/getAllPlayerList",
    selectClubOrAcademy: "/joinRequest/V2/selectClubOrAcademy",
    slotAndEventBookingFromUsersSide:
      "/venueBooking/v4/slotAndEventBookingFromUsersSide",
    holdSlots: "/venueBooking/v4/holdSlots",
    unholdSlots: "/venueBooking/v4/unholdSlots",
    createVenue: "/venue/v4/createVenue",
    cancelSlotsFromClub: "/payment/v3/refundUserByOrderId_v1",
    editGameOn: "/cards/v2/editGameOn",
    rescheduleSlotByClub: "/venueBooking/v3/_reschedulingSlots",
    venueReschedulePayment: "/venueBooking/venueReschedulePayment",
  },
  booking: {
    getBookingList: "/payment/v3/getBookedSlotsByUser",
  },
  group: {
    createGroup: "/groups/createGroup ",
  },
  payment: {
    getBankAccountList: "/payment/v2/getStripeBankAccount",
    getPaymentCardsList: "/payment/getStripePaymentMethod",
    addPaymentCards: "/payment/addPaymentMethodByCustomer",
    setAsDefaultPaymentMethod: "/payment/setAsDefaultPaymentMethod",
    removePaymentMethod: "/payment/removePaymentMethod",
    addBankAccountOnRazorPay: "/payment/v2/addBankAccountOnRazorPay ",
    uploadFileOnLocal: "users/v2/uploadFileOnLocal",
    addBankAccountOnStripe: "/payment/addBankAccountOnStripe ",
    getPaymentHistory: "/payment/v2/getBookedSlotsByUser ",
    downloadSaleExcel: "/payment/v3/downloadSaleExcel ",
    addProductRatingReviews: "/ratingReview/v2/addProductRatingReviews",
  },
  community: {
    getPMUsersList: "/player/v3/getPlayersList",
    SendConnectRequest: "/player/SendConnectRequest",
    getAcceptConnectionList: "/player/getAcceptConnectionList",
    disConnectConnection: "/player/disConnect ",
    acceptConnectionRequest: "/player/acceptConnectionRequest",
  },
  event: {
    createEvent: "/event/V2/createEvent",
    updateEvent: "/event/V2/updateEvent",
    createRequestService: "/requestService/v2/createRequestService",
    selectCrewOrAssociation: "/requestService/V2/selectCrewOrAssociation",
    updateRequestService: "/requestService/v2/editRequestService ",
    createRequestMatch: "/joinRequest/createRequestToJoinV2",
    updateRequestMatch: "/joinRequest/editRequestToJoinV2",
  },
  dashboard: {
    getPostingList: "/dashboard/v2/myPostings",
    getEventDetails: "/event/v2/eventDetails",
    getServiceDetails: "/requestService/v2/serviceRequestDetail",
    getRequestToJoinListV2: "/joinRequest/getRequestToJoinListV2",
    sendJoinAllCardRequest: "/cards/sendJoinAllCardRequest",
    getGameCards: "/cards/getGameCardsListV2 ",
    getEventListV2: "/event/getEventListV2",
    getAssignedMatches: "/dashboard/v2/crewAndVenueAssignedMatchesList",
    getRequestSentList: "/dashboard/v2/getRequestSent",
  },
};

export const API_RESPONSE = {
  SUCCESS: 1,
  FAILURE: 0,
  NOTVERIFIED: 4,
  NOTPASSWORD: 5,
};
